import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "../components/Card.js";
import { Btn, BtnLink } from "../components/Btn.js";
import { Icon, type IconName } from "../components/Icon.js";
import { useSurface } from "../lib/useSurface.js";

const INDUSTRIES: { id: string; icon: IconName; label: string }[] = [
  { id: "food", icon: "industry-food", label: "飲食・小売" },
  { id: "mfg", icon: "industry-factory", label: "製造・物流" },
  { id: "med", icon: "industry-medical", label: "医療・介護" },
  { id: "hotel", icon: "industry-hotel", label: "宿泊・サービス" },
];

/** Initial org setup wizard (step 2 of 3). */
export function Onboarding() {
  useSurface("console");
  const navigate = useNavigate();
  const [industry, setIndustry] = useState("food");

  return (
    <div className="shell">
      <div className="wiz" style={{ flex: 1, display: "grid", placeItems: "center", padding: "40px 24px" }}>
        <Card crop className="wizcard reveal" style={{ width: "100%", maxWidth: 560, padding: 34 }}>
          <div className="brand" style={{ marginBottom: 18 }}>
            <span className="glyph" aria-hidden="true" />
            TEBIKI
          </div>
          <div className="steps" style={{ display: "flex", gap: 8, marginBottom: 26 }}>
            <span className="s on" style={stepBar(true)} />
            <span className="s on" style={stepBar(true)} />
            <span className="s" style={stepBar(false)} />
          </div>
          <div className="kicker">STEP 2 / 3 — 組織のセットアップ</div>
          <h1 className="display" style={{ fontSize: 30, margin: "10px 0 4px" }}>
            あなたの<span className="hl">業種</span>は？
          </h1>
          <p className="jp" style={{ color: "var(--muted)", margin: "0 0 6px" }}>
            AIの品質レビューや安全チェックを業種に合わせて最適化します。
          </p>

          <div className="opt" style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 12, marginTop: 14 }} role="radiogroup" aria-label="業種">
            {INDUSTRIES.map((o) => (
              <button
                key={o.id}
                role="radio"
                aria-checked={industry === o.id}
                onClick={() => setIndustry(o.id)}
                style={{
                  padding: 16,
                  borderRadius: 14,
                  border: industry === o.id ? "1px solid var(--hi)" : "1px solid var(--line-2)",
                  background: "var(--surface)",
                  textAlign: "left",
                  fontSize: 15,
                  fontWeight: 600,
                  boxShadow: industry === o.id ? "0 0 0 3px color-mix(in srgb,var(--hi) 22%,transparent)" : undefined,
                }}
              >
                <span style={{ display: "block", marginBottom: 6 }} aria-hidden="true">
                  <Icon name={o.icon} size={22} />
                </span>
                {o.label}
              </button>
            ))}
          </div>

          <label className="field-label" htmlFor="orgname" style={{ marginTop: 20 }}>
            組織名
          </label>
          <input id="orgname" className="input jp" defaultValue="サンプル商事株式会社" />

          <label className="field-label" htmlFor="lang" style={{ marginTop: 14 }}>
            主な言語
          </label>
          <select id="lang" className="select">
            <option>日本語</option>
            <option>English</option>
            <option>日本語 + 英語 + ベトナム語</option>
          </select>

          <div className="row" style={{ marginTop: 26, flexWrap: "wrap" }}>
            <Btn variant="ghost" icon={<Icon name="chevron" />} style={{ whiteSpace: "nowrap" }} onClick={() => navigate("/auth")}>
              戻る
            </Btn>
            <span className="grow" />
            <BtnLink to="/dashboard" variant="primary" lg style={{ whiteSpace: "nowrap" }}>
              次へ — 完了 <Icon name="arrow-right" size={16} />
            </BtnLink>
          </div>
        </Card>
      </div>
    </div>
  );
}

const stepBar = (on: boolean) => ({ flex: 1, height: 4, borderRadius: 3, background: on ? "var(--hi)" : "var(--line)" }) as const;
